import { ImageUploader } from '../../components/ImageUploader';
import { CustomTextField } from '../../components/Inputs';
import { useTranslation } from 'react-i18next';

export function ContactFields({ formData, handleInputChange, fieldErrors }) {
  const { t } = useTranslation();

  return (
    <>
      <CustomTextField
        label={t('contactFields.studentEmail')}
        margin="normal"
        value={formData.correuElectronic}
        readOnly={true}
      />
      <CustomTextField
        label={t('contactFields.phone1')}
        margin="normal"
        value={formData.telefon1}
        error={!!fieldErrors.telefon1}
        helperText={fieldErrors.telefon1}
        onChange={(e) => handleInputChange('telefon1', e.target.value)}
      />
      <CustomTextField
        label={t('contactFields.phone2')}
        margin="normal"
        value={formData.telefon2}
        error={!!fieldErrors.telefon2}
        helperText={fieldErrors.telefon2}
        onChange={(e) => handleInputChange('telefon2', e.target.value)}
      />
      <div style={{ position: 'relative', width: '100%', justifyContent: 'center', display: 'flex', marginTop: 15 }}>
        <ImageUploader sx={{ position: 'absolute', left: '50%', transform: 'translateX(-50%)' }}/>
      </div>
    </>
  );
}
